import { render } from "./buttonComp.vue?vue&type=template&id=aa8adef6"
import script from "./buttonComp.vue?vue&type=script&lang=js"
export * from "./buttonComp.vue?vue&type=script&lang=js"

import "./buttonComp.vue?vue&type=style&index=0&id=aa8adef6&lang=css"

import exportComponent from "D:\\Programming_And_Stuff\\Programming\\VueJs\\food-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__